import business from '@/utils/business'
export function fundDetail(data){
	return business.post('/social/social-fund-detail', data)
}


export function socialList(data){
	return business.post('/social/list', data)
}


export function socialDetail(data){
	return business.post('/client-employee/social-detail', data)
}




export function fundAdd(data){
	return business.post('/fund/employee-add', data)
}


export function fundetail(data){
	return business.post('/client-employee/fund-detail', data)
}
export function WxSocList(data){
	return business.post('/client-employee/social-list', data)
}

export function WxSocmodify(data){
	return business.post('/social/employee-modify', data)
}


// WEBPACK FOOTER //
// ./src/api/Hrfund.js